<div class="c-modal__wrap cpp-modal__wrap" aria-hidden="!isOpen" [class.is--opened]="isOpen">
  <div class="c-modal__overlay cpp-modal__overlay" (click)="close()"></div>
  <div class="c-modal cpp-modal">
    <ng-container *ngIf="(content | async) as content">
      <h3 class="c-modal__title" *ngIf="content.title">{{content.title}}</h3>
      <a class="cpp-modal__close icon icon--large" href="javascript:void(0)" (click)="close()">
        <svg>
          <use xlink:href="#Close2"></use>
        </svg>
      </a>
      <article class="c-modal__message" [innerHTML]="content.body"></article>
    </ng-container>
  </div>
</div>

